import { render, staticRenderFns } from "./fileCollection.vue?vue&type=template&id=f88b1eee&"
import script from "@viewJs/excuseExam/fileCollection.js?vue&type=script&lang=js&"
export * from "@viewJs/excuseExam/fileCollection.js?vue&type=script&lang=js&"
import style0 from "./fileCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports